import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ResponsiveDialog } from "@/components/ui/responsive-dialog";
import type { NavItem } from "@/lib/navigation";
import { getDisplayName, type NavUser } from "@/lib/userDisplay";
import { NavMenu } from "./NavMenu";
import { UserAvatar } from "./UserIdentity";
import { CaretDownIcon } from "@phosphor-icons/react";

interface UserMenuProps {
  user: NavUser;
  links: NavItem[];
  onSignOut: () => void;
}

/**
 * Asztali avatar gomb: a fiók linkjeit és a kijelentkezést egy `ResponsiveDialog` mutatja
 * (asztalon dialógus, `md` alatt alsó lap) - lenyíló menü nincs, az app minden ilyen
 * kérdése dialógusban vagy lapon dől el. A tartalom a `NavMenu`, ugyanaz a komponens,
 * amit a fejléc mobil panelje is használ: a sorok kinézete egy helyen él.
 */
export function UserMenu({ user, links, onSignOut }: UserMenuProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* A nyíl a gomb natív `group/button` csoportján és az `aria-expanded`-en fordul.
          A `rounded-full` a fejléc pill-nyelve (az egyetlen hely, ahol gomb lekerekítést kap). */}
      <Button
        variant="ghost"
        className="rounded-full"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <UserAvatar user={user} />
        <span className="max-w-[120px] truncate">{getDisplayName(user)}</span>
        <CaretDownIcon
          data-icon="inline-end"
          className="text-muted-foreground transition-transform group-aria-expanded/button:rotate-180"
          aria-hidden="true"
        />
      </Button>
      <ResponsiveDialog
        open={open}
        onOpenChange={setOpen}
        title="Fiók"
        description="A fiókodhoz tartozó oldalak és a kijelentkezés."
        className="sm:max-w-sm"
      >
        <NavMenu
          label="Fiók menü"
          groups={[{ items: links }]}
          user={user}
          onSignOut={onSignOut}
          onNavigate={() => setOpen(false)}
        />
      </ResponsiveDialog>
    </>
  );
}
